// extracted by mini-css-extract-plugin
export default {"tupacGrid":"rl-z","tupacHeader":"sl-z","tupacHeader2":"tl-z","tupacMenu":"ul-z","tupacMenu2":"vl-z","tupacMain":"wl-z","tupacMain2":"xl-z"};